<template>
  <div>
    <div>
      <el-form :model="approve" size="small">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="扣除调休天数(天)">
              <el-input v-model="approve.deductDays" show-word-limit type="text" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="审批意见">
              <el-input v-model="approve.comment" maxlength="200" show-word-limit type="textarea">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <userApprove ref="userApprove" :show-default-form="false" :query-approve-data="queryApproveData"
      :validate-fn="validateApprove" v-on="$listeners" />
  </div>
</template>

<script>
// 人事主管个性化审批界面
import { notBlank } from "@/CommonDP/utils/validate";
import userApprove from "@/CommonDP/pages/components/launchFlow/components/userApprove";
import { ApproveAction } from "@/CommonDP/enums/FlowConstants";

const APPROVE = () => ({
  comment: "", // 审批意见
  deductDays: 0
});
export default {
  components: { userApprove },
  data() {
    return {
      approve: APPROVE()
    };
  },

  async mounted() {},

  methods: {
    // 接口:设置审批参数
    setFormData(formJson) {
      this.approve.formJson = formJson;
    },

    queryApproveData(action, form) {
      if (action === ApproveAction.AGREE) {
        form.comment = this.approve.comment;
        form.approveJson = JSON.stringify(this.approve);
        return form;
      }
    },

    validateApprove(action) {
      if (action === ApproveAction.AGREE) {
        const success = notBlank(this.approve.deductDays, "扣除调休天数必需大于0") && notBlank(this.approve.comment, "审核意见不能为空");
        return success ? 1 : 2;
      } else if (action === ApproveAction.REJECT) {
        const success = notBlank(this.approve.comment, "审核意见不能为空");
        return success ? 1 : 2;
      }
    }
  }
};
</script>

<style>
.approveButton {
  text-align: center;
}
</style>
